import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DashboardService } from '../../../service/api/dashboard-service';
import { showToast } from 'Core/redux/toast/slice';

export const STORE_KEY = 'dashboard';
export const INITIAL_STATE = {
  dashboardData: {
    tile1: 0,
    tile2: 0,
    tile3: 0,
    tile4: 0,
    tile5: 0,
    tile6: 0,
    tile7: 0,
    tile8: 0,
    processDetails: []
  },
  loading: false,
  error: null
};

export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchDashboardData',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await DashboardService.getDashboardData();
      console.log('API Response:', response);
      
      if (response.status === 200) {
        console.log('Response data:', response.response);
        return response.response;
      } else {
        dispatch(showToast({ message: response.errorMessage?.message || 'Failed to load dashboard data', type: 'error' }));
        return rejectWithValue(response.errorMessage?.message || 'Failed to load dashboard data');
      }
    } catch (error) {
      console.error('Dashboard API error:', error);
      dispatch(showToast({ message: error.message || 'Failed to load dashboard data', type: 'error' }));
      return rejectWithValue(error.message || 'Failed to load dashboard data');
    }
  }
);

export const { reducer, actions } = createSlice({
  name: 'dashboard',
  initialState: INITIAL_STATE,
  reducers: {
    resetDashboard: () => INITIAL_STATE,
    setDashboardDataDirectly: (state, action) => {
      state.dashboardData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        console.log('Dashboard data in reducer (before):', state.dashboardData);
        console.log('Payload in reducer:', action.payload);
        state.loading = false;
        
        // Handle both possible API response structures
        if (action.payload) {
          // Make a deep copy to ensure state update is detected
          const newData = JSON.parse(JSON.stringify(action.payload));
          state.dashboardData = newData;
          console.log('Dashboard data in reducer (after):', state.dashboardData);
        }
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        console.error('Dashboard data fetch failed:', action.payload);
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { resetDashboard, setDashboardDataDirectly } = actions;
export default reducer; 